import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import { IoClose } from "react-icons/io5";
import ToastMsg from "../../component/comman/ToastMsg";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import {
  customersDetails,
  dashboardTransactions,
  // verifyPin,
} from "../../services/ApiServices";

const NewTransactions = ({ isOpenNow, onCloseNow, onTransactionSuccess,name,userId }) => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [transactionAmount, setTransactionAmount] = useState("");
  const [transactionDate, setTransactionDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [isDebitActive, setIsDebitActive] = useState(false);
  const [isCreditActive, setIsCreditActive] = useState(false);
  const [details, setDetails] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (name) {
      setInputValue(name);
      setIsEdit(true)
    }
  }, [name]); 
  useEffect(() => {
    if(userId){
      setSelectedCustomer(userId)
    }
    const isValid =
      selectedCustomer !== "" &&
      transactionType !== "" &&
      transactionAmount !== "" &&
      transactionDate !== "";
    setIsFormValid(isValid);
  }, [selectedCustomer, transactionType, transactionAmount, transactionDate]);
  const handleAddTransaction = () => {
    const data = {
      customer: selectedCustomer,
      transaction_type: transactionType,
      transaction_amount: transactionAmount,
      transaction_date: transactionDate,
      details: details,
    };

    dashboardTransactions(data)
      .then((res) => {
        if (res.status === 201) {
          ToastMsg("Details updated successfully!", "success");
          resetFields();
          if (onTransactionSuccess) {
            onTransactionSuccess();
          }
        } else {
          console.error("Failed to update details:", res?.data);
          ToastMsg("Failed to update details", "error");
        }
        onCloseNow()
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  const handleDebitChange = (e) => {
    const value = e.target.value;
    setTransactionAmount(value);
    setIsDebitActive(!!value);
    setIsCreditActive(false);
    setTransactionType("debit");
  };

  const handleCreditChange = (e) => {
    const value = e.target.value;
    setTransactionAmount(value);
    setIsCreditActive(!!value);
    setIsDebitActive(false);
    setTransactionType("credit");
  };

  const resetFields = () => {
    setTransactionAmount("");
    setTransactionType("");
    setIsDebitActive(false);
    setIsCreditActive(false);
    setInputValue("");
    setSelectedCustomer("");
    setDetails("");
  };

  const getCustomersDetails = (name = "") => {
    return customersDetails({ name: name, per_page_data: 5 })
      .then((res) => {
        if (res.status === 200 && Array.isArray(res?.data?.data)) {
          let data = res.data.data;
          setCustomers(data);
          return data; // Return the fetched data
        }
        return [];
      })
      .catch((err) => {
        console.error("API Error:", err);
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
        return [];
      });
  };

  const filterCustomers = (input) => {
    getCustomersDetails(input)
      .then((data) => {
        const filtered = data.filter((customer) =>
          customer.name.toLowerCase().includes(input.toLowerCase())
        );
        setFilteredCustomers(filtered);
      })
      .catch((err) => {
        console.error("Error while filtering customers:", err);
      });
  };

  return (
    <>
      <section className="transaction-card">
        <div className="card mb-4">
          <div className="card-body">
            <h5 className="card-title">New Transactions</h5>
            <form className="row">
              <div className="form-group col-2">
                <label htmlFor="exampleInputDate">Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="exampleInputDate"
                  placeholder="dd/mm/yyyy"
                  value={transactionDate}
                  onChange={(e) => setTransactionDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
              <div className="form-group drop-select col-3">
                <label htmlFor="exampleInputDate">Select Account</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type Name"
                  value={inputValue}
                  onClick={
                    (e) => {
                      filterCustomers(e.target.value);
                    }
                  }
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    filterCustomers(e.target.value);

                  }}
                />
                <ul className="list-group" style={{zIndex:10}}>
                  
                {filteredCustomers.map((customer) => (
                  <li
                    key={customer.id}
                    style={{
                      backgroundColor: hoveredItem === customer.id ? "#f0f0f0" : "white",
                      borderBottom: "1px solid #eee",
                      cursor: "pointer",
                      padding: "10px",
                      transition: "background-color 0.3s ease",
                    }}
                    onMouseEnter={() => setHoveredItem(customer.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={() => {
                      setSelectedCustomer(customer.id);
                      setInputValue(customer.name);
                      setFilteredCustomers([]);
                    }}
                  >
                    {customer.name}
                  </li>
                ))}
                </ul>
              </div>
              <div className="form-group col-3">
                <label htmlFor="exampleInputCredit" className="green">Debit <TiArrowSortedDown /></label>
                <input
                  type="number"
                  className="form-control"
                  id="exampleInputCredit"
                  placeholder="Enter Amount"
                  value={isDebitActive ? transactionAmount : ""}
                  onChange={handleDebitChange}
                  disabled={isCreditActive}
                />
              </div>
              <div className="form-group col-3">
                <label htmlFor="exampleInputCredit" className="red">Credit <TiArrowSortedUp /></label>
                <input
                  type="number"
                  className="form-control"
                  id="exampleInputCredit"
                  placeholder="Enter Amount"
                  value={isCreditActive ? transactionAmount : ""}
                  onChange={handleCreditChange}
                  disabled={isDebitActive}
                />
              </div>
              <div className="form-group col-8">
                <label htmlFor="exampleInputCredit">Details</label>
                <textarea
                  className="form-control"
                  id="exampleInputCredit"
                  placeholder="Enter Details"
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                ></textarea>
              </div>
              <div className="col-1"> </div>
              <div className="col-3 text-right d-flex align-items-end justify-content-end">
                <button
                  type="button"
                  className="btn"
                  onClick={() => handleAddTransaction()}
                  disabled={!isFormValid} 
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <Popup
        open={isOpenNow}
        closeOnDocumentClick={false}
        onClose={onCloseNow}
        className="new-user journal-pop"
      >
        {console.log('name',name)}
        <div className="card">
          <div className="card-body">
            <div className="flex align-items-center justify-content-between">
              <h5>New Transaction</h5>
              <IoClose onClick={onCloseNow} />
            </div>
            <form className="row">
              <div className="form-group col-3">
                <label htmlFor="date">Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="exampleInputDate"
                  placeholder="dd/mm/yyyy"
                  value={transactionDate}
                  onChange={(e) => setTransactionDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
              <div className="form-group drop-select col-9">
                <label htmlFor="exampleInputDate">Select Account</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type Name"
                  value={inputValue}
                  onClick={(e) => {
                    filterCustomers(e.target.value);
                  }}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    filterCustomers(e.target.value);
                  }}
                  disabled={isEdit}

                />
                <ul className="list-group" style={{zIndex:10}}>
                  
                {filteredCustomers.map((customer) => (
                  <li
                    key={customer.id}
                    style={{
                      backgroundColor: hoveredItem === customer.id ? "#f0f0f0" : "white",
                      cursor: "pointer",
                      padding: "10px",
                      transition: "background-color 0.3s ease",
                      borderBottom: "1px solid #eee",
                    }}
                    onMouseEnter={() => setHoveredItem(customer.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={() => {
                      setSelectedCustomer(customer.id);
                      setInputValue(customer.name);
                      setFilteredCustomers([]);
                    }}
                  >
                    {customer.name}
                  </li>
                ))}
                          </ul>
              </div>
              <div className="form-group col-12">
                <label htmlFor="exampleInputCredit">Debit<TiArrowSortedDown style={{fill:"green"}}/></label>
                <input
                  type="number"
                  className="form-control"
                  id="exampleInputCredit"
                  placeholder="Enter Amount"
                  value={isDebitActive ? transactionAmount : ""}
                  onChange={handleDebitChange}
                  disabled={isCreditActive}
                />
              </div>
              <div className="form-group col-12">
                <label htmlFor="exampleInputCredit">Credit<TiArrowSortedUp style={{fill:"red"}}/></label>
                <input
                  type="number"
                  className="form-control"
                  id="exampleInputCredit"
                  placeholder="Enter Amount"
                  value={isCreditActive ? transactionAmount : ""}
                  onChange={handleCreditChange}
                  disabled={isDebitActive}
                />
              </div>
              <div className="form-group">
                <label htmlFor="details">Details</label>
                <textarea
                  className="form-control"
                  id="exampleInputCredit"
                  placeholder="Enter Details"
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                ></textarea>
              </div>
            </form>
            <div className="button-wrapper text-right">
              <button className="btn" onClick={onCloseNow}>
                Cancel
              </button>
              <button className="btn" onClick={() => handleAddTransaction()}>
                Save
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default NewTransactions;
